import type { EmojiProvider } from '@atlaskit/emoji';
import { EmojiResource } from '@atlaskit/emoji/resource';

const EMOJI_URL = '/gateway/api/emoji';

// Module-level caches keyed by cloudId — ensures a single EmojiResource (and therefore
// a single set of 3 network requests) is created per cloud, regardless of how many
// components call createEmojiProvider with the same cloudId.
const emojiProviderCache = new Map<string, Promise<EmojiProvider>>();
const emojiProviderWithUploadCache = new Map<string, Promise<EmojiProvider>>();

export function createEmojiProvider(cloudId: string): Promise<EmojiProvider> {
	const cached = emojiProviderCache.get(cloudId);
	if (cached) {
		return cached;
	}
	const provider = new EmojiResource({
		providers: [
			{ url: `${EMOJI_URL}/standard` },
			{ url: `${EMOJI_URL}/atlassian` },
			{ url: `${EMOJI_URL}/${cloudId}/site` },
		],
	}).getEmojiProvider();
	emojiProviderCache.set(cloudId, provider);
	return provider;
}

export function createEmojiProviderWithUpload(cloudId: string): Promise<EmojiProvider> {
	const cached = emojiProviderWithUploadCache.get(cloudId);
	if (cached) {
		return cached;
	}
	const provider = new EmojiResource({
		providers: [
			{ url: `${EMOJI_URL}/standard` },
			{ url: `${EMOJI_URL}/atlassian` },
			{ url: `${EMOJI_URL}/${cloudId}/site` },
		],
		allowUpload: true,
	}).getEmojiProvider();
	emojiProviderWithUploadCache.set(cloudId, provider);
	return provider;
}
